const AWARDS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  initialData: [],
  latestEvent: undefined,
  data: [],
  isDirty: false,
  dataForRenaming: undefined,
  mainTreeExpandedKeys: [],
  supportingTreeExpandedKeys: [],
}

export default AWARDS_INITIAL_STATE
